'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import { MdAdd, MdArrowDropDown, MdCheck, MdMoreVert, MdPlaylistAdd, MdThumbDown, MdThumbDownOffAlt, MdThumbUp, MdThumbUpOffAlt } from 'react-icons/md';
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import * as Select from '@radix-ui/react-select';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
import NextImage from 'next/image';
import { useContext as useContextSelector } from 'use-context-selector';
import ButtonWithIcon from '../../../../components/ButtonWithIcon';
import ButtonWithLabel from '../../../../components/ButtonWithLabel';
import DownloadApp from '../../../../components/DownloadApp';
import Footer from '../../../../components/Footer';
import GenresList from '../../../../components/GenresList';
import ManageListsItemsModal from '../../../../components/ManageListsItemsModal';
import MovieOrTvRating from '../../../../components/MovieOrTvRating';
import Person from '../../../../components/Person';
import ResourceItem from '../../../../components/ResourceItem';
import Wrapper from '../../../../components/Wrapper';
import AppContext from '../../../../context/AppContext';
import AuthContext from '../../../../context/AuthContext';
import buildRouteUrl from '../../../../helpers/buildRouteUrl';
import getLocalizedLanguageLabel from '../../../../helpers/getLocalizedLanguageLabel';
import useIntl from '../../../../hooks/useIntl';
import { Link } from '../../../../i18n/navigation';
import { Ad, init } from '../../../../lib/adsClient';
import api from '../../../../services/api';
import { Episode, Tv, TvToWatchNext } from '../../../../types/types';
import buildTitleUrl from '../../../../helpers/buildTitleUrl';
// import AdSense from '../AdSense';

const SeasonList = dynamic(() => import('../../../../components/SeasonList'), {
  ssr: true
});
const WatchProvidersList = dynamic(() => import('../../../../components/WatchProvidersList'), {
  ssr: true
});
const CarouselSection = dynamic(() => import('../../../../components/CarouselSection'), {
  ssr: true
});
interface PropTypes {
  initialData: Tv;
  isMobile?: boolean;
  region: string;
}
async function getTv(tvId: string, params?: any, headers?: any): Promise<{
  data: Tv;
}> {
  const response = await api.get(`/v1/tv/${tvId}`, {
    params,
    headers
  });
  return response.data;
}
function ClientTv(t0) {
  const $ = _c(117);
  const {
    initialData,
    isMobile
  } = t0;
  const queryClient = useQueryClient();
  const intl = useIntl();
  const t = useTranslations();
  const tvId = initialData._id as string;
  useState(null);
  const auth = useContext(AuthContext);
  const app = useContextSelector(AppContext);
  const [isManageListsItemsModalOpen, setIsManageListsItemsModalOpen] = useState(false);
  const t1 = `tv-${tvId}`;
  let t2;
  if ($[0] !== t1) {
    t2 = [t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== intl || $[3] !== tvId) {
    t3 = async () => await getTv(tvId, {
      region: intl.locale
    }, {
      "accept-language": intl.full_language
    });
    $[2] = intl;
    $[3] = tvId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== initialData) {
    t4 = {
      data: initialData
    };
    $[5] = initialData;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      initialData: t4
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const tvQuery = useQuery(t5);
  let t6;
  if ($[11] !== queryClient) {
    t6 = t7 => {
      const {
        tvId: tvId_1
      } = t7;
      queryClient.setQueryData(["coming-soon-episodes"], old => {
        if (old) {
          return {
            meta: old.meta,
            data: old.data.map(data => {
              if (data.tv._id === tvId_1) {
                return {
                  ...data,
                  tv: {
                    ...data.tv,
                    user_related: {
                      ...data.tv.user_related,
                      is_on_userlist: true
                    }
                  }
                };
              }
              return data;
            })
          };
        }
      });
      const previousTv = queryClient.getQueryData([`tv-${tvId_1}`]);
      queryClient.setQueryData([`tv-${tvId_1}`], _temp2);
      return () => queryClient.setQueryData([`tv-${tvId_1}`], previousTv);
    };
    $[11] = queryClient;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== queryClient) {
    t7 = () => {
      queryClient.invalidateQueries({
        queryKey: ["user-list"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-me-list-with-pagination"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-all"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-watching"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-not-started"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-stopped-watching"]
      });
    };
    $[13] = queryClient;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = {
      mutationFn: _temp,
      onMutate: t6,
      onError: _temp3,
      onSuccess: t7
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const {
    mutate: addToUserList
  } = useMutation(t8);
  let t9;
  if ($[18] !== queryClient) {
    t9 = t10 => {
      const {
        tvId: tvId_3
      } = t10;
      queryClient.setQueryData(["coming-soon-episodes"], old_1 => {
        if (old_1) {
          return {
            meta: old_1.meta,
            data: old_1.data.map(data_0 => {
              if (data_0.tv._id === tvId_3) {
                return {
                  ...data_0,
                  tv: {
                    ...data_0.tv,
                    user_related: {
                      ...data_0.tv.user_related,
                      is_on_userlist: false
                    }
                  }
                };
              }
              return data_0;
            })
          };
        }
      });
      const previousTv_0 = queryClient.getQueryData([`tv-${tvId_3}`]);
      queryClient.setQueryData([`tv-${tvId_3}`], _temp5);
      return () => queryClient.setQueryData([`tv-${tvId_3}`], previousTv_0);
    };
    $[18] = queryClient;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== queryClient) {
    t10 = () => {
      queryClient.invalidateQueries({
        queryKey: ["user-list"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-me-list-with-pagination"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-all"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-watching"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-not-started"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-stopped-watching"]
      });
    };
    $[20] = queryClient;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = {
      mutationFn: _temp4,
      onMutate: t9,
      onError: _temp6,
      onSuccess: t10
    };
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const {
    mutate: removeFromUserList
  } = useMutation(t11);
  let t12;
  if ($[25] !== queryClient) {
    t12 = {
      mutationFn: _temp7,
      onMutate: t13 => {
        const {
          tvId: tvId_5,
          rating: rating_0
        } = t13;
        const previousTv_1 = queryClient.getQueryData([`tv-${tvId_5}`]);
        queryClient.setQueryData([`tv-${tvId_5}`], old_3 => {
          if (old_3) {
            return {
              meta: old_3.meta,
              data: {
                ...old_3.data,
                user_related: {
                  ...old_3.data.user_related,
                  user_rating: rating_0
                }
              }
            };
          }
        });
        return () => queryClient.setQueryData([`tv-${tvId_5}`], previousTv_1);
      },
      onError: _temp8
    };
    $[25] = queryClient;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const {
    mutate: rateTv
  } = useMutation(t12);
  let t13;
  if ($[27] !== queryClient) {
    t13 = t14 => {
      const {
        tvId: tvId_7
      } = t14;
      const previousTv_2 = queryClient.getQueryData([`tv-${tvId_7}`]) as {
        data: Tv;
      };
      queryClient.setQueryData([`tv-${tvId_7}`], _temp10);
      previousTv_2.data.seasons.forEach(season => {
        const previousSeason = queryClient.getQueryData([`tv-${tvId_7}-seasons-${season.season_number}`]);
        queryClient.setQueryData([`tv-${tvId_7}-seasons-${season.season_number}`], _temp12);
        return () => queryClient.setQueryData([`tv-${tvId_7}-seasons-${season.season_number}`], previousSeason);
      });
      return () => queryClient.setQueryData([`tv-${tvId_7}`], previousTv_2);
    };
    $[27] = queryClient;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== auth.userData?._id || $[30] !== queryClient) {
    t14 = () => {
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-all"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-watching"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-not-started"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-stopped-watching"]
      });
      queryClient.invalidateQueries({
        queryKey: [`users-${auth.userData?._id}`]
      });
      queryClient.invalidateQueries({
        queryKey: ["me-detailed-statistics"]
      });
      queryClient.invalidateQueries({
        queryKey: [`user-${auth.userData?._id}-watch-list-tvs-with-pagination`]
      });
    };
    $[29] = auth.userData?._id;
    $[30] = queryClient;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = {
      mutationFn: _temp9,
      onMutate: t13,
      onError: _temp13,
      onSuccess: t14
    };
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const {
    mutate: markWholeTvAsWatched
  } = useMutation(t15);
  let t16;
  if ($[35] !== queryClient) {
    t16 = t17 => {
      const {
        tvId: tvId_9
      } = t17;
      const previousTv_3 = queryClient.getQueryData([`tv-${tvId_9}`]) as {
        data: Tv;
      };
      queryClient.setQueryData([`tv-${tvId_9}`], _temp15);
      previousTv_3.data.seasons.forEach(season_0 => {
        const previousSeason_0 = queryClient.getQueryData([`tv-${tvId_9}-seasons-${season_0.season_number}`]);
        queryClient.setQueryData([`tv-${tvId_9}-seasons-${season_0.season_number}`], _temp17);
        return () => queryClient.setQueryData([`tv-${tvId_9}-seasons-${season_0.season_number}`], previousSeason_0);
      });
      return () => queryClient.setQueryData([`tv-${tvId_9}`], previousTv_3);
    };
    $[35] = queryClient;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== auth.userData?._id || $[38] !== queryClient) {
    t17 = () => {
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-all"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-watching"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-not-started"]
      });
      queryClient.invalidateQueries({
        queryKey: ["user-tv-to-watch-next-stopped-watching"]
      });
      queryClient.invalidateQueries({
        queryKey: [`users-${auth.userData?._id}`]
      });
      queryClient.invalidateQueries({
        queryKey: ["me-detailed-statistics"]
      });
      queryClient.invalidateQueries({
        queryKey: [`user-${auth.userData?._id}-watch-list-tvs-with-pagination`]
      });
    };
    $[37] = auth.userData?._id;
    $[38] = queryClient;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t16 || $[41] !== t17) {
    t18 = {
      mutationFn: _temp14,
      onMutate: t16,
      onError: _temp18,
      onSuccess: t17
    };
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  const {
    mutate: unmarkWholeTvAsWatched
  } = useMutation(t18);
  let t19;
  if ($[43] !== queryClient) {
    t19 = {
      mutationFn: _temp19,
      onMutate: t20 => {
        const {
          tvId: tvId_11,
          watchingState: watchingState_0
        } = t20;
        if (watchingState_0 === "stop_watching") {
          queryClient.setQueryData([`tv-${tvId_11}`], _temp20);
          queryClient.setQueryData(["user-tv-to-watch-next-all"], old_9 => ({
            data: old_9.data.filter(tvToWatchNext => {
              if (tvToWatchNext._id !== tvId_11) {
                return tvToWatchNext;
              }
            })
          }));
        }
        if (watchingState_0 === "resume_watching") {
          queryClient.setQueryData([`tv-${tvId_11}`], _temp21);
        }
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["user-tv-to-watch-next-all"]
        });
        queryClient.invalidateQueries({
          queryKey: ["user-tv-to-watch-next-watching"]
        });
        queryClient.invalidateQueries({
          queryKey: ["user-tv-to-watch-next-not-started"]
        });
        queryClient.invalidateQueries({
          queryKey: ["user-tv-to-watch-next-stopped-watching"]
        });
      },
      onError: _temp22
    };
    $[43] = queryClient;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  const {
    mutate: updateTvWatchingState
  } = useMutation(t19);
  let t20;
  if ($[45] !== addToUserList || $[46] !== removeFromUserList || $[47] !== tvId || $[48] !== tvQuery.data?.data?.user_related?.is_on_userlist) {
    t20 = function handleAddOrRemoveUserList() {
      if (tvQuery.data?.data?.user_related?.is_on_userlist) {
        removeFromUserList({
          tvId
        });
      } else {
        addToUserList({
          tvId
        });
      }
    };
    $[45] = addToUserList;
    $[46] = removeFromUserList;
    $[47] = tvId;
    $[48] = tvQuery.data?.data?.user_related?.is_on_userlist;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const handleAddOrRemoveUserList = t20;
  let t21;
  if ($[50] !== markWholeTvAsWatched || $[51] !== tvId || $[52] !== tvQuery.data?.data?.user_related?.is_fully_watched || $[53] !== unmarkWholeTvAsWatched) {
    t21 = function handleWatchWholeTv() {
      if (tvQuery.data?.data?.user_related?.is_fully_watched) {
        unmarkWholeTvAsWatched({
          tvId
        });
      } else {
        markWholeTvAsWatched({
          tvId
        });
      }
    };
    $[50] = markWholeTvAsWatched;
    $[51] = tvId;
    $[52] = tvQuery.data?.data?.user_related?.is_fully_watched;
    $[53] = unmarkWholeTvAsWatched;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  const handleWatchWholeTv = t21;
  let t22;
  if ($[55] !== rateTv || $[56] !== tvId || $[57] !== tvQuery.data?.data?.user_related?.user_rating) {
    t22 = function likeTv() {
      if (tvQuery.data?.data?.user_related?.user_rating === 2) {
        rateTv({
          tvId,
          rating: 0
        });
      } else {
        rateTv({
          tvId,
          rating: 2
        });
      }
    };
    $[55] = rateTv;
    $[56] = tvId;
    $[57] = tvQuery.data?.data?.user_related?.user_rating;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  const likeTv = t22;
  let t23;
  if ($[59] !== rateTv || $[60] !== tvId || $[61] !== tvQuery.data?.data?.user_related?.user_rating) {
    t23 = function dislikeTv() {
      if (tvQuery.data?.data?.user_related?.user_rating === 1) {
        rateTv({
          tvId,
          rating: 0
        });
      } else {
        rateTv({
          tvId,
          rating: 1
        });
      }
    };
    $[59] = rateTv;
    $[60] = tvId;
    $[61] = tvQuery.data?.data?.user_related?.user_rating;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  const dislikeTv = t23;
  let t24;
  if ($[63] !== tvQuery.data?.data?.release_date) {
    t24 = new Date(String(tvQuery?.data?.data?.release_date)).getFullYear() || null;
    $[63] = tvQuery.data?.data?.release_date;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  const fullYear = t24;
  let t25;
  if ($[65] !== tvQuery.data?.data?.seasons) {
    t25 = tvQuery.data?.data?.seasons.filter(_temp23).length;
    $[65] = tvQuery.data?.data?.seasons;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  const seasonsCount = t25;
  let T0;
  let t26;
  let t27;
  let t28;
  let t29;
  if ($[67] !== app || $[68] !== auth.isLoading || $[69] !== auth.isLoggedIn || $[70] !== dislikeTv || $[71] !== fullYear || $[72] !== handleAddOrRemoveUserList || $[73] !== handleWatchWholeTv || $[74] !== initialData.overview || $[75] !== initialData.title || $[76] !== intl || $[77] !== isManageListsItemsModalOpen || $[78] !== isMobile || $[79] !== likeTv || $[80] !== seasonsCount || $[81] !== t || $[82] !== tvId || $[83] !== tvQuery.data || $[84] !== tvQuery.isSuccess || $[85] !== updateTvWatchingState) {
    const cast = tvQuery.data?.data.credits.filter(_temp24);
    const t30 = tvQuery.data?.data.original_language;
    let t31;
    if ($[91] !== t || $[92] !== t30) {
      t31 = getLocalizedLanguageLabel(t30, t);
      $[91] = t;
      $[92] = t30;
      $[93] = t31;
    } else {
      t31 = $[93];
    }
    const originalLanguageLabel = t31;
    let t32;
    if ($[94] !== app || $[95] !== tvId || $[96] !== tvQuery.data?.data.seasons) {
      t32 = tvQuery.data?.data.seasons.find(season_2 => season_2.season_number === app.getCurrentSeasonOpen(tvId));
      $[94] = app;
      $[95] = tvId;
      $[96] = tvQuery.data?.data.seasons;
      $[97] = t32;
    } else {
      t32 = $[97];
    }
    const selectedSeason = t32;
    T0 = Wrapper;
    let t33;
    if ($[98] !== initialData.overview || $[99] !== initialData.title) {
      t33 = JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "TVSeries",
        name: initialData.title,
        description: initialData.overview
      });
      $[98] = initialData.overview;
      $[99] = initialData.title;
      $[100] = t33;
    } else {
      t33 = $[100];
    }
    if ($[101] !== t33) {
      t28 = <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: t33
      }} />;
      $[101] = t33;
      $[102] = t28;
    } else {
      t28 = $[102];
    }
    if ($[103] !== auth.isLoading || $[104] !== auth.isLoggedIn || $[105] !== isManageListsItemsModalOpen || $[106] !== tvQuery.data?.data) {
      t29 = !auth.isLoading && auth.isLoggedIn && tvQuery.data?.data._id && <ManageListsItemsModal isOpen={isManageListsItemsModalOpen} onClose={() => setIsManageListsItemsModalOpen(false)} data={{
        contentId: tvQuery.data?.data._id,
        contentType: "tv"
      }} />;
      $[103] = auth.isLoading;
      $[104] = auth.isLoggedIn;
      $[105] = isManageListsItemsModalOpen;
      $[106] = tvQuery.data?.data;
      $[107] = t29;
    } else {
      t29 = $[107];
    }
    t26 = "m-h-[100vh]";
    t27 = tvQuery.isSuccess && <div className="flex flex-col w-full"><div className={"\n                flex\n                flex-col\n                md:flex-row\n                px-4 md:px-10\n                py-4 md:py-6\n                relative\n              "} style={{
        backgroundImage: !isMobile ? `linear-gradient(rgba(20, 20, 20, 0.958), rgba(20, 20, 20, 0.958)), url(https://cdn-proxy.trakio.app/t/p/w1920_and_h800_multi_faces${tvQuery.data?.data?.wallpaper?.file_path})` : `linear-gradient(rgba(20, 20, 20, 0.958), rgba(20, 20, 20, 0.958)), url(https://cdn-proxy.trakio.app/t/p/w300${tvQuery.data?.data?.wallpaper?.file_path})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}>{isMobile && <div className="flex flex-col md:hidden"><NextImage className="rounded-md bg-gray-400 mr-4 z-[2] min-w-[70px] w-[70px] h-[105px]" src={`https://cdn-proxy.trakio.app/t/p/w92${tvQuery.data?.data?.poster?.file_path}`} alt={t("images_alts.tv_poster", {
            title: tvQuery.data.data.title
          })} width={70} height={105} unoptimized={true} /><h1 className="text-white text-2xl font-bold">{tvQuery.data?.data.title}{" "}{fullYear ? " - " + fullYear : ""}</h1>{!auth.isLoading && auth.isLoggedIn && <div className="flex flex-1 justify-end items-start md:hidden"><DropdownMenu.Root><DropdownMenu.Trigger className="flex justify-center items-center w-[40px] h-[40px] rounded-full px-4 bg-white hover:bg-gray-200"><MdMoreVert size={18} className="text-black" /></DropdownMenu.Trigger><DropdownMenu.Portal style={{
                zIndex: 100
              }} className="z-10"><DropdownMenu.Content align="end" sideOffset={5} className="w-48 rounded-lg p-2 shadow-md md:w-56 bg-black z-10">{tvQuery.data.data.user_related.watching_state === "is_watching" && <DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => {
                      updateTvWatchingState({
                        tvId,
                        watchingState: "stop_watching"
                      });
                    }} className="flex-grow text-white">{t("tv_to_watch_next.menu.stop_watching")}</span></DropdownMenu.Item>}{tvQuery.data.data.user_related.watching_state === "stopped_watching" && <DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => {
                      updateTvWatchingState({
                        tvId,
                        watchingState: "resume_watching"
                      });
                    }} className="flex-grow text-white">{t("tv_to_watch_next.menu.resume_watching")}</span></DropdownMenu.Item>}</DropdownMenu.Content></DropdownMenu.Portal></DropdownMenu.Root></div>}</div>}{typeof isMobile === "undefined" && <div className="flex md:hidden"><NextImage className="rounded-md bg-gray-400 mr-4 z-[2] min-w-[70px] w-[70px] h-[105px]" width={70} height={105} src={tvQuery.data?.data?.poster?.file_path ? `https://cdn-proxy.trakio.app/t/p/w92${tvQuery.data?.data?.poster?.file_path}` : "/assets/app/poster-fallback.jpg"} alt={t("images_alts.tv_poster", {
            title: tvQuery.data.data.title
          })} unoptimized={true} /><h1 className="text-white text-2xl font-bold">{tvQuery.data?.data.title}{fullYear ? " - " + fullYear : ""}</h1>{!auth.isLoading && auth.isLoggedIn && tvQuery.data.data.user_related && <div className="flex flex-row flex-1 justify-end items-start md:hidden"><DropdownMenu.Root><DropdownMenu.Trigger className="flex justify-center items-center w-[40px] h-[40px] rounded-full px-4 bg-white hover:bg-gray-200"><MdMoreVert size={18} className="text-black" /></DropdownMenu.Trigger><DropdownMenu.Portal style={{
                zIndex: 100
              }} className="z-10"><DropdownMenu.Content align="end" sideOffset={5} className="w-48 rounded-lg p-2 shadow-md md:w-56 bg-black z-10">{tvQuery.data.data.user_related.watching_state === "is_watching" && <DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => {
                      updateTvWatchingState({
                        tvId,
                        watchingState: "stop_watching"
                      });
                    }} className="flex-grow text-white">{t("tv_to_watch_next.menu.stop_watching")}</span></DropdownMenu.Item>}{tvQuery.data.data.user_related.watching_state === "stopped_watching" && <DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => {
                      updateTvWatchingState({
                        tvId,
                        watchingState: "resume_watching"
                      });
                    }} className="flex-grow text-white">{t("tv_to_watch_next.menu.resume_watching")}</span></DropdownMenu.Item>}</DropdownMenu.Content></DropdownMenu.Portal></DropdownMenu.Root></div>}</div>}{!isMobile && <NextImage className="rounded-md bg-gray-400 mr-4 z-[2] hidden md:block min-w-[360px] w-[360px] h-[540px]" width={360} height={540} src={tvQuery.data?.data?.poster?.file_path ? `https://cdn-proxy.trakio.app/t/p/w500${tvQuery.data?.data?.poster?.file_path}` : "/assets/app/poster-fallback.jpg"} alt={t("images_alts.tv_poster", {
          title: tvQuery.data.data.title
        })} unoptimized={true} />}<div className="flex flex-col w-full"><div className="flex flex-row justify-between"><div className="flex flex-col">{!isMobile && <h1 className="hidden md:block text-white text-3xl font-bold">{tvQuery.data?.data.title}{fullYear ? " - " + fullYear : ""}</h1>}<p className="w-[100%] lg:w-[60%] text-white text-md line-clamp-6 mt-1">{tvQuery.data?.data.overview}</p></div>{!auth.isLoading && auth.isLoggedIn && tvQuery.data.data.user_related && <div className="hidden md:flex md:items-start md:justify-start"><DropdownMenu.Root><DropdownMenu.Trigger className="flex justify-center items-center w-[40px] h-[40px] rounded-full px-4 bg-white hover:bg-gray-200"><MdMoreVert size={18} className="text-black" /></DropdownMenu.Trigger><DropdownMenu.Portal style={{
                  zIndex: 100
                }} className="z-10"><DropdownMenu.Content align="end" sideOffset={5} className="w-48 rounded-lg p-2 shadow-md md:w-56 bg-black z-10">{tvQuery.data.data.user_related.watching_state === "is_watching" && <DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => {
                        updateTvWatchingState({
                          tvId,
                          watchingState: "stop_watching"
                        });
                      }} className="flex-grow text-white">{t("tv_to_watch_next.menu.stop_watching")}</span></DropdownMenu.Item>}{tvQuery.data.data.user_related.watching_state === "stopped_watching" && <DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => {
                        updateTvWatchingState({
                          tvId,
                          watchingState: "resume_watching"
                        });
                      }} className="flex-grow text-white">{t("tv_to_watch_next.menu.resume_watching")}</span></DropdownMenu.Item>}</DropdownMenu.Content></DropdownMenu.Portal></DropdownMenu.Root></div>}</div><div className="flex text-white mt-2">{!!seasonsCount && <div className="flex mr-2 h-[25px] items-center justify-center whitespace-nowrap"><span className="text-base font-bold">{seasonsCount} {t("tv_show.metadata.seasons")}</span></div>}{!!fullYear && <div className="flex mr-2 h-[25px] items-center justify-center whitespace-nowrap"><span className="text-base font-bold">{fullYear}</span></div>}{!!tvQuery?.data?.data?.certification && <div className="flex mr-2 h-[25px] items-center justify-center whitespace-nowrap"><span className="text-base font-bold">{tvQuery?.data?.data?.certification || "NA"}</span></div>}{!!tvQuery?.data?.data?.status && <div className="flex mr-2 h-[25px] items-center justify-center whitespace-nowrap"><span className="text-base font-bold">{t(`tv_show.status.${tvQuery?.data?.data?.status}`)}</span></div>}</div><GenresList data={tvQuery.data?.data.genres || []} from_page="tv" /><MovieOrTvRating data={{
            internal_rating: tvQuery.data?.data.average_rating || 0,
            imdb_rating: tvQuery.data?.data.imdb_rating
          }} />{!auth.isLoading && auth.isLoggedIn && tvQuery.data?.data.user_related && <div className="flex flex-row mt-8"><ButtonWithLabel className="mr-3" onClick={likeTv} label={t("common.like")} icon={tvQuery.data?.data.user_related.user_rating === 2 ? <MdThumbUp className="text-white" size={26} /> : <MdThumbUpOffAlt className="text-white" size={26} />} /><ButtonWithLabel className="mr-3" onClick={dislikeTv} label={t("common.dislike")} icon={tvQuery.data?.data.user_related.user_rating === 1 ? <MdThumbDown className="text-white" size={26} /> : <MdThumbDownOffAlt className="text-white" size={26} />} /><ButtonWithLabel className="mr-3" onClick={handleAddOrRemoveUserList} label={t("tv_show.my_list")} icon={tvQuery.data?.data.user_related.is_on_userlist ? <MdCheck className="text-white" size={26} /> : <MdAdd className="text-white" size={26} />} /><ButtonWithLabel onClick={() => setIsManageListsItemsModalOpen(true)} label={t("tv_show.list")} icon={<MdPlaylistAdd className="text-white" size={26} />} /></div>}{!auth.isLoading && auth.isLoggedIn && tvQuery.data?.data.user_related && <div className="flex flex-row mt-6"><ButtonWithIcon onClick={handleWatchWholeTv} icon={tvQuery.data?.data.user_related.is_fully_watched ? <MdCheck className="text-white" size={20} /> : <MdAdd className="text-white" size={20} />}>{tvQuery.data?.data.user_related.is_fully_watched ? t("tv_show.not_watched_all") : t("tv_show.watched_all")}</ButtonWithIcon></div>}</div></div><div className={"flex flex-row items-start justify-between flex-wrap px-4 md:px-10\n                py-4 md:py-6"}><div className="w-full"><WatchProvidersList id={`tvs-${tvId}-watch-providers`} contentTitle={tvQuery.data.data.title} data={tvQuery.data?.data.watch_providers || []} className="mb-6" />{(cast?.length || 0) > 0 && <CarouselSection id={`tvs-${tvId}-cast`} title={t("tv_show.sections.cast")} type="person" totalItems={cast?.length || 0} className="mb-6">{cast?.map(_temp25)}</CarouselSection>}{(tvQuery.data?.data.seasons?.length || 0) > 0 && <div className="flex flex-col mt-6"><span className="text-white text-2xl font-normal">{t("tv_show.sections.episodes")}</span><Select.Root defaultValue="1" value={String(selectedSeason?.season_number || 1)} onValueChange={value => app.openSeasonsList(tvId, Number(value))}><Select.Trigger aria-label="Select season" className="inline-flex self-start items-center justify-center rounded-md px-4 text-sm h-[40px] gap-2 bg-black text-white mt-2 font-bold"><Select.Value className="text-white" /><Select.Icon><MdArrowDropDown size={18} className="text-white" /></Select.Icon></Select.Trigger><Select.Portal><Select.Content className="overflow-hidden bg-black rounded-md"><Select.Viewport className="p-2"><Select.Group><Select.Label className="flex h-10 rounded-md select-none text-white items-center px-2 py-4 relative">{t("tv_show.episodes.select_season")}</Select.Label>{tvQuery.data.data.seasons.map(season_3 => <Select.Item key={season_3.season_number} className="flex h-10 rounded-md text-white items-center px-2 relative outline-none data-[highlighted]:bg-gray-200 cursor-pointer" value={String(season_3.season_number)}><Select.ItemText className="text-white">{t("tv_show.episodes.season_name", {
                            season_number: season_3.season_number
                          })}</Select.ItemText><Select.ItemIndicator /></Select.Item>)}</Select.Group></Select.Viewport></Select.Content></Select.Portal></Select.Root>{selectedSeason && <SeasonList key={selectedSeason.season_number} data={{
              available_episodes: tvQuery.data?.data.available_episodes,
              tv_id: tvQuery.data?.data._id,
              tvTitle: tvQuery.data?.data.title,
              name: selectedSeason.name,
              season_number: selectedSeason.season_number,
              is_fully_watched: !auth.isLoading && auth.isLoggedIn ? selectedSeason?.user_related?.is_fully_watched : undefined,
              number_of_watched_episodes: !auth.isLoading && auth.isLoggedIn ? selectedSeason?.user_related?.number_of_watched_episodes : undefined
            }} />}</div>}{(tvQuery.data?.data?.related_tvs?.length || 0) > 0 && <CarouselSection id={`tvs-${tvId}-related_tvs`} title={t("tv_show.sections.you_may_also_like", {
            title: tvQuery.data.data.title
          })} type="resource" totalItems={tvQuery.data.data.related_tvs.length || 0} className="mt-12 mb-6">{tvQuery.data.data.related_tvs.map(item_0 => <Link key={item_0._id} href={buildTitleUrl({
              type: "tv",
              locale: intl.locale.toLowerCase(),
              shortId: item_0.short_id,
              slugs: item_0.slugs
            })} prefetch={false}><div className="embla__slide"><ResourceItem className="mr-2" data={{
                  ...item_0,
                  type: "tv"
                }} /></div></Link>)}</CarouselSection>}<div className="w-full mt-20"><h2 className="text-white text-2xl font-normal">{t("tv_show.additional_data.title", {
                content_title: tvQuery.data.data.title
              })}</h2><div className="grid grid-cols-1 md:grid-cols-2 gap-10"><div className="flex flex-col w-full lg-[w-1/2]">{!!tvQuery.data.data.overview && <h3 className="text-white text-lg font-bold mt-2">{t("tv_show.additional_data.overview", {
                    content_title: tvQuery.data.data.title
                  })}</h3>}{!!tvQuery.data.data.overview && <p className="text-[#a3a3a3] mt-2">{tvQuery.data.data.overview}</p>}{tvQuery.data.data.certification && <div className="mt-2"><strong className="text-white">{t("tv_show.additional_data.certification")}:</strong>{" "}<span className="text-[#a3a3a3]">{tvQuery.data.data.certification}</span></div>}{tvQuery.data?.data.seasons.length > 0 && <div className="mt-2"><strong className="text-white">{t("tv_show.additional_data.number_of_seasons")}:</strong>{" "}<span className="text-[#a3a3a3]">{tvQuery?.data?.data?.seasons.length}</span></div>}{tvQuery.data?.data.available_episodes.length > 0 && <div className="mt-2"><strong className="text-white">{t("tv_show.additional_data.number_of_episodes")}:</strong>{" "}<span className="text-[#a3a3a3]">{tvQuery?.data?.data?.available_episodes.length}</span></div>}</div><div className="flex flex-col w-full lg-[w-1/2]"><h3 className="text-white text-lg font-bold mt-2">{t("tv_show.additional_data.extra_details")}</h3>{!!tvQuery.data.data.original_title && tvQuery.data.data.original_title !== "xx" && <div className="mt-2"><strong className="text-white">{t("tv_show.additional_data.original_title")}:</strong>{" "}<span className="text-[#a3a3a3]">{tvQuery.data?.data.original_title}</span></div>}{!!originalLanguageLabel && <div className="mt-2"><strong className="text-white">{t("tv_show.additional_data.original_language")}:</strong>{" "}<span className="text-[#a3a3a3]">{originalLanguageLabel}</span></div>}{!!tvQuery.data?.data.budget && <div className="mt-2"><strong className="text-white">{t("tv_show.additional_data.budget")}:</strong>{" "}<span className="text-[#a3a3a3]">{tvQuery.data?.data.budget.toLocaleString("us-US", {
                      style: "currency",
                      currency: "USD"
                    })}</span></div>}{!!tvQuery.data?.data.revenue && <div className="mt-2"><strong className="text-white">{t("tv_show.additional_data.revenue")}:</strong>{" "}<span className="text-[#a3a3a3]">{tvQuery.data?.data.revenue.toLocaleString("us-US", {
                      style: "currency",
                      currency: "USD"
                    })}</span></div>}{tvQuery.data?.data.production_companies.length > 0 && <div className="mt-2"><span className="font-bold text-white">{t("tv_show.additional_data.production_companies")}</span><div className="flex flex-row flex-wrap">{tvQuery.data?.data.production_companies.map((productionCompany, index) => {
                      const isLastItem = tvQuery.data.data.production_companies.length - 1 === index;
                      return <span key={productionCompany.name} className="text-[#a3a3a3]">{productionCompany.name}{tvQuery.data.data.production_companies.length > 1 && !isLastItem && ",\xA0"}</span>;
                    })}</div></div>}<div className="mt-2">{tvQuery.data?.data.watch_providers.filter(_temp26).filter(_temp27).length > 0 ? <><strong className="text-white">{t("tv_show.additional_data.where_to_watch")}</strong><p className="text-[#a3a3a3]">{t("tv_show.additional_data.where_to_watch_list", {
                        content_title: tvQuery.data.data.title
                      })}{" "}{tvQuery.data.data.watch_providers.filter(_temp28).filter(_temp29).map((watchProvider, index_0, arr) => {
                        const isLastItem_0 = arr.length - 1 === index_0;
                        return <a key={watchProvider.provider._id} target="_blank" rel="noreferrer" className="hover:opacity-[0.5]" href={watchProvider.url}><strong>{watchProvider.provider.name}{tvQuery.data.data.watch_providers.length > 1 && !isLastItem_0 && ", "}</strong></a>;
                      })}</p></> : <div><strong className="text-white">{t("tv_show.additional_data.where_to_watch")}</strong><p className="text-[#a3a3a3]">{t("tv_show.additional_data.no_where_to_watch", {
                        title: tvQuery.data.data.title
                      })}</p></div>}</div></div></div></div><DownloadApp /></div></div></div>;
    $[67] = app;
    $[68] = auth.isLoading;
    $[69] = auth.isLoggedIn;
    $[70] = dislikeTv;
    $[71] = fullYear;
    $[72] = handleAddOrRemoveUserList;
    $[73] = handleWatchWholeTv;
    $[74] = initialData.overview;
    $[75] = initialData.title;
    $[76] = intl;
    $[77] = isManageListsItemsModalOpen;
    $[78] = isMobile;
    $[79] = likeTv;
    $[80] = seasonsCount;
    $[81] = t;
    $[82] = tvId;
    $[83] = tvQuery.data;
    $[84] = tvQuery.isSuccess;
    $[85] = updateTvWatchingState;
    $[86] = T0;
    $[87] = t26;
    $[88] = t27;
    $[89] = t28;
    $[90] = t29;
  } else {
    T0 = $[86];
    t26 = $[87];
    t27 = $[88];
    t28 = $[89];
    t29 = $[90];
  }
  let t30;
  if ($[108] !== t26 || $[109] !== t27) {
    t30 = <div className={t26}>{t27}</div>;
    $[108] = t26;
    $[109] = t27;
    $[110] = t30;
  } else {
    t30 = $[110];
  }
  let t31;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Footer />;
    $[111] = t31;
  } else {
    t31 = $[111];
  }
  let t32;
  if ($[112] !== T0 || $[113] !== t28 || $[114] !== t29 || $[115] !== t30) {
    t32 = <T0>{t28}{t29}{t30}{t31}</T0>;
    $[112] = T0;
    $[113] = t28;
    $[114] = t29;
    $[115] = t30;
    $[116] = t32;
  } else {
    t32 = $[116];
  }
  return t32;
}
function _temp29(watchProviderOffer) {
  return !(watchProviderOffer.provider.slug === "unofficial" || watchProviderOffer.provider.slug === "theater");
}
function _temp28(v, i, a) {
  return a.findIndex(t_0 => t_0.url === v.url) === i;
}
function _temp27(watchProviderOffer_0) {
  return !(watchProviderOffer_0.provider.slug === "unofficial" || watchProviderOffer_0.provider.slug === "theater");
}
function _temp26(v_0, i_0, a_0) {
  return a_0.findIndex(t_1 => t_1.url === v_0.url) === i_0;
}
function _temp25(item) {
  return <div key={item._id} className="embla__slide"><Person key={item._id} data={item} /></div>;
}
function _temp24(credit) {
  return credit.type === "cast" && credit.avatar;
}
function _temp23(season_1) {
  return season_1.season_number !== 0;
}
function _temp22(err_4, __4, rollback_4) {
  return rollback_4();
}
function _temp21(old_10) {
  return {
    data: {
      ...old_10.data,
      user_related: {
        ...old_10.data.user_related,
        watching_state: "is_watching"
      }
    }
  };
}
function _temp20(old_8) {
  return {
    data: {
      ...old_8.data,
      user_related: {
        ...old_8.data.user_related,
        watching_state: "stopped_watching"
      }
    }
  };
}
async function _temp19(t0) {
  const {
    tvId: tvId_10,
    watchingState
  } = t0;
  const response_4 = await api.put("/v1/me/tv-watching-state", {
    tv_id: tvId_10,
    watching_state: watchingState
  });
  return response_4.data;
}
function _temp18(err_3, __3, rollback_3) {
  return rollback_3();
}
function _temp17(old_7) {
  if (!old_7) {
    return;
  }
  return {
    data: {
      ...old_7.data,
      episodes: old_7.data.episodes.map(_temp16)
    }
  };
}
function _temp16(episode_0) {
  return {
    ...episode_0,
    user_related: {
      ...episode_0.user_related,
      is_watched: false
    }
  };
}
function _temp15(old_6) {
  return {
    data: {
      ...old_6.data,
      user_related: {
        ...old_6.data.user_related,
        is_fully_watched: false
      }
    }
  };
}
async function _temp14(t0) {
  const {
    tvId: tvId_8
  } = t0;
  const response_3 = await api.post("/v1/me/unmark-whole-tv-as-watched", {
    tv_id: tvId_8
  });
  return response_3.data;
}
function _temp13(err_2, __2, rollback_2) {
  return rollback_2();
}
function _temp12(old_5) {
  if (!old_5) {
    return;
  }
  return {
    data: {
      ...old_5.data,
      episodes: old_5.data.episodes.map(_temp11)
    }
  };
}
function _temp11(episode) {
  if (episode.released) {
    return {
      ...episode,
      user_related: {
        ...episode.user_related,
        is_watched: true
      }
    };
  }
  return episode;
}
function _temp10(old_4) {
  return {
    data: {
      ...old_4.data,
      user_related: {
        ...old_4.data.user_related,
        is_fully_watched: true
      }
    }
  };
}
async function _temp9(t0) {
  const {
    tvId: tvId_6
  } = t0;
  const response_2 = await api.post("/v1/me/mark-whole-tv-as-watched", {
    tv_id: tvId_6
  });
  return response_2.data;
}
function _temp8(err_1, __1, rollback_1) {
  return rollback_1();
}
async function _temp7(t0) {
  const {
    tvId: tvId_4,
    rating
  } = t0;
  const response_1 = await api.post(`/v1/tv/${tvId_4}/rating`, {
    rating
  });
  return response_1.data;
}
function _temp6(err_0, __0, rollback_0) {
  return rollback_0();
}
function _temp5(old_2) {
  if (old_2) {
    return {
      data: {
        ...old_2.data,
        user_related: {
          ...old_2.data.user_related,
          is_on_userlist: false
        }
      }
    };
  }
}
async function _temp4(t0) {
  const {
    tvId: tvId_2
  } = t0;
  const response_0 = await api.delete("/v1/me/list", {
    data: {
      content_id: tvId_2,
      content_type: "tv"
    }
  });
  return response_0.data;
}
function _temp3(err, _, rollback) {
  return rollback();
}
function _temp2(old_0) {
  if (old_0) {
    return {
      data: {
        ...old_0.data,
        user_related: {
          ...old_0.data.user_related,
          is_on_userlist: true
        }
      }
    };
  }
}
async function _temp(t0) {
  const {
    tvId: tvId_0
  } = t0;
  const response = await api.post("/v1/me/list", {
    content_id: tvId_0,
    content_type: "tv"
  });
  return response.data;
}
export default ClientTv;